import React, { useState, useEffect } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { jsonp } from '@ifeng-fe/ui_base';
import styles from './index.css';
import Content from './Content';
import Result from './Result';

const Cover = () => {
    // 问题列表state
    const [qaList, setQaList] = useState([]);
    // 当前所在的题目state
    const [current, setCurrent] = useState(0);
    // 获得的分数state
    const [score, setScore] = useState(0);

    const [isEnterResult, setIsEnterResult] = useState(false);

    const initData = async () => {
        try {
            // 获取数据
            const res = await jsonp(
                'https://shankapi.ifeng.com/feedflow/coopdoc/doc_2d51dd28bfa28802815a4e8d4f5419ec/info/callback',
                {
                    jsonp: 'callback',
                    jsonpCallback: 'callback',
                    cache: false,
                },
            );

            // 请求成功
            if (res.code === 0 && Array.isArray(res?.data?.data) && res?.data?.data?.length) {
                // 接口返回的原始数据数组
                const originList = res.data.data;
                // 按权重分组之后的Map对象
                const groupMap = new Map();
                // keywords的Map对象
                const keywordsMap = new Map();
                // 最终选出的八道题的数组
                let finalList = [];
                // 所有图片图片的题目数组
                const allPicList = [];
                // 第一张图片随机数据
                let firstPicItem = {};

                // 打乱原始数据数据的顺序，为了：1、防止每次60权重的分组都在前边 2、每个分类取两道题可以直接顺序取
                originList.sort(() => Math.random() - 0.5);

                // 按权重分组
                originList.forEach(item => {
                    const { weights } = item;
                    
                    if (!item.video_url && item.img_url) {
                        allPicList.push(item);
                    }

                    if (groupMap.has(weights)) {
                        groupMap.get(weights).push(item);
                    } else {
                        groupMap.set(weights, [item]);
                    }
                });
                
                firstPicItem = allPicList[Math.floor(Math.random() * allPicList.length)];
                if (firstPicItem.keywords && firstPicItem.keywords.trim()) {
                    const firstPicKeywordsList = firstPicItem.keywords.toString().split('、');

                    firstPicKeywordsList.forEach(firstKeyword => {
                        keywordsMap.set(firstKeyword, 1);
                    });
                }

                // 从每个权重取出两道题（时间紧，不考虑不够两道之类的问题
                for (const list of groupMap.values()) {
                    // 每个权重已取题目的计数器
                    let count = 0;

                    // 遍历每个权重的题目列表
                    for (const item of list) {
                        if (firstPicItem.weights === item.weights && count >= 1) {
                            break;
                        }

                        // 如果已经取了两道题，跳出循环
                        if (count >= 2) {
                            break;
                        }

                        // 单个题目的关键词
                        const { keywords } = item;
                        // 该题目是否可用，初始值为真
                        let canuse = true;

                        if (keywords && keywords.trim()) {
                            // 如果存在关键词
                            // 以中文顿号、切分关键词
                            const keywordsList = keywords.toString().split('、');

                            // 判断该关键词的题目是否已经选出两道
                            keywordsList.forEach(keyword => {
                                if (keywordsMap.has(keyword) && keywordsMap.get(keyword) >= 2) {
                                    // 如果已经选中两道，该题目可用状态为假
                                    canuse = false;
                                }
                            });

                            if (canuse) {
                                // 如果题目可用，将题目关键词放入关键词Map对象中
                                keywordsList.forEach(keyword => {
                                    if (keywordsMap.has(keyword)) {
                                        keywordsMap.set(keyword, keywordsMap.get(keyword) + 1);
                                    } else {
                                        keywordsMap.set(keyword, 1);
                                    }
                                });
                            }
                        }

                        if (canuse && item.title !== firstPicItem.title) {
                            // 如果题目可用，放入最终选出的八道题的数组
                            finalList.push(item);
                            // 计数加一
                            count += 1;
                        }
                    }
                }
                // 最终选出的八道题的数组打乱顺序，防止相同权重的题目连在一起
                finalList.sort(() => Math.random() - 0.5);

                finalList.unshift(firstPicItem);

                // 赋值给state
                setQaList(finalList);
            } else {
                throw new Error('请求格式有误');
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        initData();
    }, []);

    const changeIndex = index => {
        if (index < qaList.length) {
            setCurrent(index);
        } else {
            // 结果页
            setIsEnterResult(true);
        }
    };

    const changeScore = score => {
        setScore(prev => prev + score);
    };

    return (
        isEnterResult ? <Result score={score} />
        : <div className={styles.wrap}>
            {qaList.length ? (
                <Content
                    data={qaList[current]}
                    index={current}
                    total={qaList.length}
                    changeIndex={changeIndex}
                    changeScore={changeScore}
                    key={current}
                />
            ) : null}
        </div>
    );
};

export default errorBoundary(Cover);
